/* Анкета нового тренера (REG-3): имя, фамилия, город, согласие с условиями — в стиле
   profile.html. Сюда попадает каждый новый аккаунт сразу после входа по коду (Login.tsx
   там имени и согласия больше не спрашивает — незачем заново у уже вошедших). */
import { trpc } from '@tg/app-core';
import { useState } from 'react';
import type { Me } from '../lib/data';
import { toast } from '../ui/Toast';

export function Onboarding({ me }: { me: Me }) {
  const utils = trpc.useUtils();
  const [f, setF] = useState({ first: me.first, last: me.last, city: me.city || '' });
  const [agree, setAgree] = useState(false);
  const save = trpc.trainer.updateProfile.useMutation({
    onSuccess: () => utils.trainer.me.invalidate(),
    onError: (e) => toast(e.message || 'Не сохранилось — попробуйте ещё раз'),
  });
  const ready = !!f.first.trim() && !!f.last.trim() && agree;
  const submit = () => {
    if (!ready || save.isPending) return;
    save.mutate({ first: f.first.trim(), last: f.last.trim(), city: f.city.trim() || null, termsAccepted: true });
  };
  return (
    <div className="auth onb">
      <div className="auth-brand">
        <div className="auth-lg">
          <span>Тренерграм</span>
        </div>
        <p>Последний шаг — и кабинет готов: клиенты, программы и тренировки в одном месте.</p>
      </div>
      <div className="auth-side">
        <form
          className="auth-card"
          onSubmit={(e) => {
            e.preventDefault();
            submit();
          }}
        >
          <h1>Расскажите о себе</h1>
          <p className="lead">Это увидят клиенты, когда откроют вашу ссылку-приглашение. Остальное можно дополнить в профиле.</p>
          <div className="formfld">
            <span className="k">Имя</span>
            <input className="inp" autoFocus autoComplete="given-name" value={f.first} onChange={(e) => setF({ ...f, first: e.target.value })} placeholder="Иван" />
          </div>
          <div className="formfld">
            <span className="k">Фамилия</span>
            <input className="inp" autoComplete="family-name" value={f.last} onChange={(e) => setF({ ...f, last: e.target.value })} placeholder="Петров" />
          </div>
          <div className="formfld">
            <span className="k">
              Город <s>необязательно</s>
            </span>
            <input className="inp" autoComplete="address-level2" value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} placeholder="Москва" />
          </div>
          <label className={'onb-agree' + (agree ? ' on' : '')}>
            <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} />
            <span>
              Принимаю{' '}
              <a className="lnk" href="https://trenergram.ru/oferta" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                условия оферты
              </a>{' '}
              и{' '}
              <a className="lnk" href="https://trenergram.ru/privacy" target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                политику конфиденциальности
              </a>
            </span>
          </label>
          <button className="btn auth-go" disabled={!ready || save.isPending}>
            {save.isPending ? 'Сохраняем…' : 'Перейти в кабинет'}
          </button>
        </form>
      </div>
    </div>
  );
}
